@if (highlight()) {
  <div class="row  payment-methods">
    <div class="col-md-4 col-sm-4">
      <img [ngClass]="{'selected-payment-method':validateBrandName('mastercard'),'payment-method':!validateBrandName('mastercard')}"
        [src]="imgService.getPaymentBrand('mastercard')" alt="mastercard">
    </div>
    <div class="col-md-4 col-sm-4">
      <img [ngClass]="{'selected-payment-method':validateBrandName('visa'),'payment-method':!validateBrandName('visa')}"
        [src]="imgService.getPaymentBrand('visa')" alt="visa">
    </div>
    <div class="col-md-4 col-sm-4">
      <img [ngClass]="{'selected-payment-method':validateBrandName('maestro'),'payment-method':!validateBrandName('maestro')}"
        [src]="imgService.getPaymentBrand('maestro')" alt="maestro">
    </div>
  </div>
} @else {
  <div class="col-md-12">
    @if (validateBrandName('mastercard')) {
      <img class="selected-payment-method unicity"
        [src]="imgService.getPaymentBrand('mastercard')" alt="mastercard">
    }
    @if (validateBrandName('visa')) {
      <img class="selected-payment-method visaUnicity"
        [src]="imgService.getPaymentBrand('visa')" alt="visa">
    }
    @if (validateBrandName('maestro')) {
      <img class="selected-payment-method unicity"
        [src]="imgService.getPaymentBrand('maestro')" alt="maestro">
    }
  </div>
}
